<script lang="ts">
  import { setAccordionOptions } from './context';

  // by default more than one accordion can be open
  export let collapse: boolean = false;
  export let customClass = '';

  // the context API avoids passing data through components as props
  setAccordionOptions({ collapse });
</script>

<div class="bg-white {customClass}">
  <slot />
</div>
